import React from 'react';
import Beira from './stages/Beira';
import './Timeline.css'
import Nagapattinam from './stages/Nagapattinam';
import Colombo from './stages/Colombo';

export default class Timeline extends React.Component {
  constructor(props) {
    super(props);
    this.incrementStage = this.incrementStage.bind(this);
    this.decrementStage = this.decrementStage.bind(this);
    this.state = {
      currentStage: 0, canIncrement: true, canDecrement: false,
      stageContents: new Beira().getStages(),
      stageFunctions: [
        // 0 - zoom to global aoi, show basemap layer, hide ff, sf, structures
        (function() {
          const index = 0;
          this.props.map.fitBounds(this.state.stageContents[index].aoi);
          this.props.map.setLayoutProperty("structures-1", 'visibility', 'none');
          // special case for colombo, we don't have any 2019 analytics
          this.props.map.setLayoutProperty("structures-columbo-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("ss-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-2", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-3", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-2", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-3", 'visibility', 'none');
        }).bind(this),
        // 1 - zoom to aoi, show basemap layer, hide ff, sf, structures
        (function() {
          const index = 1;
          this.props.map.fitBounds(this.state.stageContents[index].aoi);
          this.props.map.setLayoutProperty("structures-1", 'visibility', 'none');
          // special case for colombo, we don't have any 2019 analytics
          this.props.map.setLayoutProperty("structures-columbo-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("ss-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-2", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-3", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-2", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-3", 'visibility', 'none');
        }).bind(this),
        // 3 - zoom to aoi, show structures, hide flood frequency, sf
        (function() {
          const index = 2;
          this.props.map.fitBounds(this.state.stageContents[index].aoi);
          this.props.map.setLayoutProperty("structures-1", 'visibility', 'visible');
          this.props.map.setLayoutProperty("structures-columbo-1", 'visibility', 'visible');
          this.props.map.setLayoutProperty("ss-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-2", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-3", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-2", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-3", 'visibility', 'none');
        }).bind(this),
        // 4 - zoom to aoi, show flood frequency, hide structures & sf, show FF legend
        (function() {
          const index = 3;
          this.props.map.fitBounds(this.state.stageContents[index].aoi);
          this.props.map.setLayoutProperty("structures-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-columbo-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("ss-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-1", 'visibility', 'visible');
          this.props.map.setLayoutProperty("flood-2", 'visibility', 'visible');
          this.props.map.setLayoutProperty("flood-3", 'visibility', 'visible');
          this.props.map.setLayoutProperty("structures-in-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-2", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-3", 'visibility', 'none');
        }).bind(this),
        // 5 - zoom to aoi, show structures, ff, sf, show FF & SF legend
        (function() {
          const index = 4;
          this.props.map.fitBounds(this.state.stageContents[index].aoi);
          this.props.map.setLayoutProperty("structures-1", 'visibility', 'visible');
          this.props.map.setLayoutProperty("structures-columbo-1", 'visibility', 'visible');
          this.props.map.setLayoutProperty("ss-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-1", 'visibility', 'visible');
          this.props.map.setLayoutProperty("flood-2", 'visibility', 'visible');
          this.props.map.setLayoutProperty("flood-3", 'visibility', 'visible');
          this.props.map.setLayoutProperty("structures-in-flood-1", 'visibility', 'visible');
          this.props.map.setLayoutProperty("structures-in-flood-2", 'visibility', 'visible');
          this.props.map.setLayoutProperty("structures-in-flood-3", 'visibility', 'visible');
        }).bind(this),
        // 6 - zoom to aoi, show basemap layer + ss-flood, hide ff, sf, structures
        (function() {
          const index = 5;
          this.props.map.fitBounds(this.state.stageContents[index].aoi);
          this.props.map.setLayoutProperty("structures-1", 'visibility', 'none');
          // special case for colombo, we don't have any 2019 analytics
          this.props.map.setLayoutProperty("structures-columbo-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("ss-flood-1", 'visibility', 'visible');
          this.props.map.setLayoutProperty("flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-2", 'visibility', 'none');
          this.props.map.setLayoutProperty("flood-3", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-1", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-2", 'visibility', 'none');
          this.props.map.setLayoutProperty("structures-in-flood-3", 'visibility', 'none');
        }).bind(this),

      ]};
  }

  componentDidMount() {
    const regions = {
      'Beira': new Beira().getStages(), //Mozamique
      'Nagapattinam': new Nagapattinam().getStages(), //Tamil Nadu, India
      'Colombo': new Colombo().getStages(), //Sri Lanka
    };
    const timeline = this;
    //custom zoom to region control
    const zoomToAoi = function() {
      const value = document.getElementsByClassName('pl-ctrl-aoi-select')[0]
        .value;
      timeline.setState({stageContents: regions[value], currentStage: 0});
    };

    //Append drop-down after search
    //const topLeftControl = document.getElementsByClassName(
    //  'mapboxgl-ctrl-top-left'
    //)[0];
    const aoiDiv = document.createElement('div');
    aoiDiv.className = 'pl-ctrl-aoi mapboxgl-ctrl mapboxgl-ctrl-group';
    const select = document.createElement('select');
    select.className = 'pl-ctrl-aoi-select mapboxgl-ctrl';
    select.onchange = zoomToAoi;

    aoiDiv.appendChild(select);
    Object.keys(regions).forEach(function(key) {
      const option = document.createElement('option');
      option.value = key;
      option.innerHTML = key;
      select.appendChild(option);
    });
    //topLeftControl.appendChild(aoiDiv);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentStage !== prevState.currentStage || this.state.stageContents !== prevState.stageContents) {
      this.setStage(this.state.currentStage);
    }
  }

  /*
   * Init: Zoom to AOI, restrict nav bounds, init stage
   * 0 - zoom to aoi, show basemap layer, hide ff, sf, structures
   * 1 - zoom to aoi, show structures, hide flood freqiency, sf
   * 2 - zoom to aoi, show flood frequency, hide structures & sf, show FF legend
   * 3 - zoom to aoi, show structures, ff, sf, show FF & SF legend
   * [4 - zoom to aoi, show coverage percent dialog in place of legends]
   * 
   * >>> have two - stageFunction and stageText
   */

  setStage(stage) {
    let canIncrement = true;
    let canDecrement = true;

    if (stage === 0) {
      canDecrement = false;
    }
    if (this.state.stageFunctions[stage+1] === undefined) {
      canIncrement = false;
    }
    if (this.state.stageFunctions[stage] !== undefined) {
      this.state.stageFunctions[stage]();
      this.setState({currentStage: stage, canIncrement: canIncrement, canDecrement: canDecrement});
    }
  }

  incrementStage() {
    if (this.state.stageFunctions[this.state.currentStage+1] !== undefined) {
      this.setStage(this.state.currentStage+1);
    }
  }

  decrementStage() {
    if (this.state.currentStage > 0) {
      this.setStage(this.state.currentStage-1);
    }
  }

  render() {
    return (
      <div className="layout-timeline-container">
        <div className="layout-timeline-float-container">
          {this.state.stageContents[this.state.currentStage].description}
          {this.state.stageContents[this.state.currentStage].legend}
        </div>
        <div className="layout-timeline">
        <button className="layout-button layout-button-decrement mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored" onClick={this.decrementStage} disabled={!this.state.canDecrement}>
          <i className="material-icons">keyboard_arrow_left</i>
        </button>
        <div className="layout-timeline-content" ></div>
        <button className="layout-button layout-button-increment mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored" onClick={this.incrementStage} disabled={!this.state.canIncrement}>
          <i className="material-icons">keyboard_arrow_right</i>
        </button>
        </div>
      </div>
    );
  }

}